
export class AccountOrganisationStorageService {
  
  static LOCAL_STORAGE_KEY = 'AccountOrganisationInfoData';
  
  /** @type {UserOrganisationInfoData | null} */
  _accountOrganisationInfo = null;
  
  get accountOrganisationInfo() {
    if (!this._accountOrganisationInfo && this._isLocalStorageAvailable) {
      try {
        const storageData = window.localStorage.getItem(AccountOrganisationStorageService.LOCAL_STORAGE_KEY);
        this.accountOrganisationInfo = JSON.parse(storageData);
      } catch (e) {
        return;
      }
    }
    return this._accountOrganisationInfo;
  }
  
  /**
   * @param {UserOrganisationInfoData | null} data
   */
  set accountOrganisationInfo(data) {
    if (this._isLocalStorageAvailable) {
      if (data) {
        window.localStorage.setItem(AccountOrganisationStorageService.LOCAL_STORAGE_KEY, JSON.stringify(data));
      } else {
        window.localStorage.removeItem(AccountOrganisationStorageService.LOCAL_STORAGE_KEY);
      }
    }
    this._accountOrganisationInfo = data || null;
  }
  
  get _isLocalStorageAvailable() {
    try {
      window.localStorage.setItem('LocalStorageAvailability_test', 'LocalStorageAvailability_test');
      window.localStorage.removeItem('LocalStorageAvailability_test');
      return true;
    } catch (e) {
      return false;
    }
  }
  
}
